import { render, staticRenderFns } from "./BreadCrumbItems.vue?vue&type=template&id=eecfe1d4&scoped=true&"
import script from "./BreadCrumbItems.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbItems.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbItems.vue?vue&type=style&index=0&id=eecfe1d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eecfe1d4",
  null
  
)

export default component.exports